import { ICmsDocument, IInteriorDesignFilter } from '@features/cms/typescript';
const getFilteredArticlesByFilters = (articles: ICmsDocument[], filters: IInteriorDesignFilter[]) => {
  const compressedFilters: Record<string, number[]> = {};
  filters.forEach(filter => {
    if (filter.isChecked && filter.articlesIds.length) {
      const existing = compressedFilters[filter.type] ?? [];
      compressedFilters[filter.type] = [...new Set([...existing, ...filter.articlesIds])];
    }
  });
  const filterIdLists = Object.values(compressedFilters);
  const idsInAllCompressedFilterRecords: number[] = filterIdLists.length === 0 ? [] : filterIdLists.reduce<number[]>((intersection, ids) => intersection.filter(id => ids.includes(id)), filterIdLists[0]);
  if (idsInAllCompressedFilterRecords.length === 0) {
    return [];
  }
  return articles.filter(article => article?.id && idsInAllCompressedFilterRecords.includes(article.id));
};
export default getFilteredArticlesByFilters;